<template>
  <b-modal id="email-modal" ref="modal" size="lg" :title="title" @show="setData" @hidden="resetModal"
           @ok="handleOk" ok-title="Save">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Email</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="email" class="form-control" :state="isValidEmail(input_data.email)" v-model="input_data.email" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Email Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.email_type" v-model="input_data.email_type" :reduce="email_type=>email_type.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="description"
                      placeholder="Description"
                      rows="4"
                      v-model="input_data.desc"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.default"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status change by employee</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.is_locked"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Status change
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal, BFormTextarea, BFormRadioGroup, BFormCheckbox} from "bootstrap-vue"
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "EmailInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      title:"Add",
      input_data:{
        email:"",
        email_type:"",
        desc:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      },
      options:{
        email_type:[],
        status:[{text:"Active", value:"active"}, { text:"Non Active", value:"non_active"}],
        default:[{text:"Yes", value:true}, { text:"No", value:false}],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    isValidEmail(inputText)
    {
        let  mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        let result = false
        if(inputText.match(mailformat))
        {
          result = true;
        }

        return result
    },
    onSubmit(){
      let payload = {
        emp_id :this.$store.getters.empId,
        user_id:this.$store.getters.userId,
        email_email:this.input_data.email,
        email_emailtype_id:this.input_data.email_type,
        email_desc:this.input_data.desc,
        email_status:this.input_data.status == 'active' ? 1:0
      }

      if (this.data !== null){
        payload.id =this.data.id
        AxiosCall.Put(payload, urlApi.email.update).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.email.add).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.input_data = {
            email:this.data.email,
            email_type:this.data.type_id,
            desc:this.data.desc,
            status:this.data.status == 1 ? 'active':'non_active',
            default:this.data.is_default == 1 ? true: false,
            is_locked:"accepted"
          }
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.input_data = {
        email:"",
        email_type:"",
        desc:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      }
    },
    getEmailType(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.email.type).then(res=>{
        if(res.success){
          this.options.email_type = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  },
  created() {
    this.getEmailType()
  }
}
</script>